/*
Un usuario "con identidad" es el que tiene datos de token. `getUserData()` emite al inicio un string
vacio (""), y se exige un objeto: sobre un string, `data?.sub` NO es undefined sino la funcion nativa
String.prototype.sub (HTML legacy), que es truthy. Sin esta guarda, un usuario sin sesion (pantalla de
login) se lee como logueado y termina en /no-role.

Archivo hoja, sin imports: lo usan app-routing, UnauthorizedComponent y NoRoleComponent, y asi no suma
ciclos de modulo (ver docs/testing-jest.md).
*/
export const hasUserIdentity = (data: unknown): boolean => {
  if (data === null || typeof data !== 'object') return false;

  const { sub, name, preferred_username, email } = data as Record<string, unknown>;
  return Boolean(sub || name || preferred_username || email);
};
